/* global axios */

// Aceleres — Fase 1 Equipes: sincroniza canais (inboxes) e distribution_mode
// de uma equipe via PATCH /api/v1/accounts/:id/teams/:teamId (teams_controller).
const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

export default {
  update(teamId, payload) {
    return axios.patch(
      `/api/v1/accounts/${accountId()}/teams/${teamId}`,
      payload
    );
  },
  // Aceleres — Fase 3: acesso aos atendimentos por equipe (all|team|attendant).
  getAttendanceAccess(teamId) {
    return axios.get(
      `/api/v1/accounts/${accountId()}/teams/${teamId}/aceleres/attendance_access`
    );
  },
  updateAttendanceAccess(teamId, accessLevel) {
    return axios.patch(
      `/api/v1/accounts/${accountId()}/teams/${teamId}/aceleres/attendance_access`,
      { access_level: accessLevel }
    );
  },
  getMetaWindowReminders(teamId) {
    return axios.get(
      `/api/v1/accounts/${accountId()}/teams/${teamId}/aceleres/meta_window_reminders`
    );
  },
  updateMetaWindowReminders(teamId, payload) {
    return axios.patch(
      `/api/v1/accounts/${accountId()}/teams/${teamId}/aceleres/meta_window_reminders`,
      payload
    );
  },
};
